import ajax from '../ajax'

const BASE_URL = '/tax'

const _tax = {
  login(bus_no) {
    return ajax
      .post(`${BASE_URL}/login`, { bus_no })
      .then(response => response.data)
  },

  getDate(bus_no) {
    console.log('getDate API 호출:', { bus_no })
    return ajax.get(`${BASE_URL}/date/${bus_no}`).then(response => {
      console.log('getDate API 응답:', response.data)
      return response.data
    })
  },

  getDetail(bus_no, adjust_ym) {
    console.log('getDetail API 호출:', { bus_no, adjust_ym })
    return ajax
      .get(`${BASE_URL}/detail/${bus_no}/${adjust_ym}`)
      .then(response => {
        console.log('getDetail API 응답:', response.data)
        return response.data
      })
  },

  getList(bus_no) {
    return ajax
      .get(`${BASE_URL}/list`, {
        params: { bus_no },
      })
      .then(response => response.data)
  },

  sendEmail(email, pdfBase64) {
    console.log('📤 taxAPI.sendEmail 호출:', { email, pdfBase64Length: pdfBase64?.length })
    return ajax
      .post(`${BASE_URL}/email`, {
        email,
        pdfBase64,
      })
      .then(response => {
        console.log('✅ taxAPI.sendEmail 성공:', response.data)
        return response.data
      })
      .catch(error => {
        console.error('❌ taxAPI.sendEmail 실패:', error)
        throw error
      })
  },
}

export default _tax
